import React from 'react';
import { PageFlip, Page } from '../components/PageFlip';
import Joyride from 'react-joyride';
import { Card, Button, Typography, Row, Col, Modal, Alert } from 'antd';
import { FilePdfOutlined, CloudDownloadOutlined, EyeOutlined, CameraOutlined } from '@ant-design/icons';
import './OrientacoesFotograficas.css';

const { Title, Paragraph } = Typography;

export default class OrientacoesFotograficas extends React.Component {
  state = {
    paginas: [],
    run: false,
    modalVisible: false,
    steps: [
      {
        content: (
          <div>
            <h3>Bem-vindo(a) a página de orientações fotográficas!</h3>
            <span style={{ textAlign: "center" }}>
              Preparamos alguns arquivos que vão te ajudar a nos enviar os arquivos corretamente.
            </span>
          </div>
        ),
        placement: 'center',
        target: '#divContent'
      }
    ]
  }

  componentWillMount() {
    if (localStorage.getItem("tutorialOrientacoesFotograficas") === null) {
      this.setState({ run: true });
      localStorage.setItem("tutorialOrientacoesFotograficas", true);
    }
    let paginas = [];
    // Só existem 19 páginas, de 0 a 18
    for (let i = 0; i < 19; i++) {
      paginas.push(i);
    }
    this.setState({ paginas });
  }

  openModal = () => {
    this.setState({ modalVisible: true }, () => {
      // Tenta inicializar o flipbook após o modal abrir e renderizar o conteúdo
      setTimeout(() => {
        try {
          if (window.recarregarPageFlip) window.recarregarPageFlip();
        } catch (e) {
          console.log("Erro ao carregar PageFlip", e);
        }
      }, 500);
    });
  }

  closeModal = () => {
    this.setState({ modalVisible: false });
  }

  render() {
    const primaryColor = '#d32f2f';

    return (
      <div style={{ padding: '24px', backgroundColor: '#f0f2f5', minHeight: '100vh', display: 'flex', justifyContent: 'center' }}>
        <Row justify="center" style={{ width: '100%', maxWidth: '1000px' }}>
          <Col span={24}>

            <div id="divContent">
              <Card
                bordered={false}
                style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', overflow: 'hidden' }}
                bodyStyle={{ padding: '40px' }}
              >
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                  <div style={{
                    width: 80, height: 80, backgroundColor: '#ffebee', borderRadius: '50%', margin: '0 auto 20px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    <CameraOutlined style={{ fontSize: 40, color: primaryColor }} />
                  </div>
                  <Title level={2} style={{ color: '#212121', marginBottom: 16 }}>Orientações Fotográficas</Title>
                  <Paragraph style={{ fontSize: '16px', color: '#616161', maxWidth: '800px', margin: '0 auto' }}>
                    Segue abaixo o material que preparamos para orientar vocês na regulação do equipamento fotográfico, captação de imagens e do enquadramento correto de fotografias para aplicação em Convites de Formatura. É importante seguir esses materiais para conseguirmos manter um padrão, tornando o convite mais harmônico e equilibrado.
                  </Paragraph>
                </div>

                <Alert
                  message="Material Importante"
                  description="A leitura deste material é fundamental para garantir a qualidade final do seu convite."
                  type="info"
                  showIcon
                  style={{ marginBottom: 32, backgroundColor: '#e3f2fd', border: '1px solid #bbdefb' }}
                />

                <Row gutter={[24, 24]} justify="center">
                  <Col xs={24} sm={8}>
                    <Button
                      type="primary"
                      size="large"
                      block
                      style={{
                        height: '100%', minHeight: '120px',
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        backgroundColor: primaryColor, borderColor: primaryColor, borderRadius: '8px',
                        boxShadow: '0 4px 10px rgba(211, 47, 47, 0.3)'
                      }}
                      onClick={this.openModal}
                    >
                      <EyeOutlined style={{ fontSize: '32px', marginBottom: '8px' }} />
                      <span style={{ fontSize: '16px', fontWeight: 600 }}>Visualizar Agora</span>
                    </Button>
                  </Col>
                  <Col xs={24} sm={8}>
                    <Button
                      size="large"
                      block
                      href="/pdfs/Orientações Fotográficas.pdf"
                      download="Orientações Fotográficas.pdf"
                      style={{
                        height: '100%', minHeight: '120px',
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        borderColor: '#d9d9d9', borderRadius: '8px', color: '#424242'
                      }}
                    >
                      <FilePdfOutlined style={{ fontSize: '32px', marginBottom: '8px', color: '#d32f2f' }} />
                      <span style={{ fontSize: '16px', fontWeight: 600 }}>Baixar PDF</span>
                    </Button>
                  </Col>
                </Row>
              </Card>
            </div>

            <Modal
              title="Manual de Orientações Fotográficas"
              visible={this.state.modalVisible}
              onCancel={this.closeModal}
              footer={[
                <Button key="close" onClick={this.closeModal}>
                  Fechar
                </Button>
              ]}
              width="65%"
              centered
              bodyStyle={{ padding: 0, backgroundColor: '#333' }}
            >
              <div style={{ padding: '20px', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <PageFlip>
                  {
                    this.state.paginas.map((item, i) => {
                      return (
                        <Page key={i} isVegetal={false}>
                          <img alt="Página do pdf" style={{ width: "100%" }} src={`https://alpha-agencia.s3-sa-east-1.amazonaws.com/orientacoes-fotograficas/${i}.jpg`} />
                        </Page>
                      )
                    })
                  }
                </PageFlip>
              </div>
            </Modal>

            <Joyride
              steps={this.state.steps}
              continuous={true}
              run={this.state.run}
              scrollToFirstStep={true}
              showProgress={true}
              showSkipButton={true}
              locale={{
                back: 'Voltar',
                close: 'Fechar',
                last: 'Entendi',
                next: 'Próximo',
                skip: 'Pular'
              }}
              styles={{
                options: {
                  primaryColor: primaryColor,
                  zIndex: 10000,
                },
              }} />
          </Col>
        </Row>
      </div>
    )
  }
}